<template>
	<div class="row" v-if="parent_data" >
		<span class="cb-lapel-parent">
			<input type="checkbox" :id="id" :value="id" v-model="checked" :disabled="disabled" @change="handle_cb_click">
			<span class="cb-label">{{ label }}</span>
		</span>
		<span class="cb-price-parent">
			<span v-if="checked">
				<!-- <el-textarea v-if="editable" :parent_data="parent_data" property="rent" :editable="editable" width="20px" /> -->
				<input class="cb-price" type="number" :name="id + '_price'" :id="id + '_price'" v-model="price">
				<span>{{ suffix }}</span>
			</span>
			<!-- <p v-else>&nbsp;</p> -->
		</span>
	</div>
	<!-- <div v-if="parent_data" class="element el-textarea" :style="{ 'max-width': width }" :class="{ 'can-change': is_editable }">
		<span v-show="is_editable && placeholder && is_empty" class="placeholder">{{ placeholder }}</span>
		<p class="input" :class="{ editable: is_editable }" ref="textarea" :contenteditable="is_editable" @keyup="set_empty()" @blur="change($event)" v-html="display_value"></p>
	</div> -->
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";


export default {
	name: "el-checkbox-number",
	mixins: [ ElementMixin ],
	data: function () {
		return {
			is_empty: true,
		};
	},
	props: {
		placeholder: { default: "" },
		width: { default: "100%" },
		editable: { default: false },
		format: { default: "number" },
		suffix: { default: "" },
		disabled: { default: false },
	},
	computed: {
		...mapGetters([ ]),
		id () { return this.parent_data.id; },
		checked: {
			get () { return this.parent_data.checked; },
			set (new_value) {
				this.$store.dispatch("edit_object", {
					obj: this.parent_data,
					field: "checked",
					value: new_value,
				});
				if (new_value === false) {
					this.price = 0;
				}
			}
		},
		label () { return this.parent_data.label; },
		price: {
			get () { return this.parent_data.rent_price; },
			set (new_value) {
				this.$store.dispatch("edit_object", {
					obj: this.parent_data,
					field: "rent_price",
					value: new_value,
				});
			}
		},
		value: function () {
			return this.parent_data;
		},
	},
	methods: {
		handle_cb_click () {
			// console.log(this.checked);
		},
		change: function (e) {
			if (this.is_editable) this.edit_study(e.target.innerHTML);
		},
	},
	mounted: function () {
	},
};
</script>


<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.cb-lapel-parent
	width 120px
	
.cb-price-parent
	width 120px !important
	.cb-price
		float right
		width 120px

</style>